// recharge-plan-labels overwrite

document.addEventListener('DOMContentLoaded', function () {
  console.log('Recharge plan label overrides (with click + mutation) loaded');

  var planLabels = ['3 months to pay', '6 months to pay', '9 months to pay'];

  function applyPlanLabels(root) {
    if (!root) return;

    try {
      var buttons = Array.from(
        root.querySelectorAll('div.rc-plans-button, [part~="rc-plans-button"]')
      );

      buttons.forEach(function (btn, index) {
        if (index >= planLabels.length) return;

        // Element that holds the "1 month" text
        var intervalEl =
          btn.querySelector('[part*="rc-plans-button__interval"]') ||
          btn.firstElementChild;

        if (intervalEl) {
          intervalEl.textContent = planLabels[index];
        }
      });

      // Also apply inside nested shadowRoots (rc-selling-plans uses them)
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          applyPlanLabels(el.shadowRoot);
        }
      });
    } catch (e) {
      console.warn('Recharge plan label error:', e);
    }
  }

  function initWidget(widget) {
    if (!widget.shadowRoot) return;

    var root = widget.shadowRoot;

    // Initial apply
    applyPlanLabels(root);

    // 1) Watch for any DOM/text changes inside the widget
    var obs = new MutationObserver(function () {
      applyPlanLabels(root);
    });
    obs.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // 2) Also re-apply shortly after any click inside the widget
    root.addEventListener('click', function () {
      setTimeout(function () {
        applyPlanLabels(root);
      }, 50); // small delay so Recharge can update first
    });
  }

  function initAllWidgets() {
    document
      .querySelectorAll('recharge-subscription-widget')
      .forEach(initWidget);
  }

  // Run once now
  initAllWidgets();

  // In case the widget is injected later
  var globalObserver = new MutationObserver(function () {
    initAllWidgets();
  });
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
